module.exports = [
  require('./beast_bond'),
  require('./bones_of_the_earth'),
]
